import { render, staticRenderFns } from "./GroupRoleList.vue?vue&type=template&id=1299833c&"
import script from "./GroupRoleList.vue?vue&type=script&lang=js&"
export * from "./GroupRoleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports